import { render, staticRenderFns } from "./NominationConferenceEdit.vue?vue&type=template&id=4e5027d4&scoped=true"
import script from "./NominationConferenceEdit.vue?vue&type=script&lang=js"
export * from "./NominationConferenceEdit.vue?vue&type=script&lang=js"
import style0 from "./NominationConferenceEdit.vue?vue&type=style&index=0&id=4e5027d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5027d4",
  null
  
)

export default component.exports